/* ============
 * Mutation types for the account module
 * ============
 *
 * The mutation types that are available
 * on the auth module.
 */

export const MEDIAS = 'MEDIAS';
export const MULTI_SELECT = 'MULTI_SELECT';
export const INIT_MULTI_SELECT = 'INIT_MULTI_SELECT';

export default {
  MEDIAS,
  MULTI_SELECT,
  INIT_MULTI_SELECT,
};
